var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dcw-seniority-levels"},[_vm._l((_vm.filteredLevels),function(seniorityLevel,index){return [_c('li',{key:(seniorityLevel + "-" + index),staticClass:"dcw-seniority-levels__item"},[_c('span',{class:{
          'dcw-seniority-levels__level--active': _vm.level === seniorityLevel
        }},[_vm._v("\n        "+_vm._s(seniorityLevel)+"\n      ")])])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }